import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import CommonLayout from "../../../../_utils/CommonLayout";
import AccountName from "../../../../_utils/AccountCreationComponents/AccountName";

const FieldForceAccountName = ({
  payload,
  selectedValue,
  setSelectedValue,
  accountNameValidation,
  setAccountNameValidation,
  setPayload,
  parentCreateBen,
  activeStep,
  BenEnableNextButton,
  bankAccountName,
}) => {
  const { panVerificationData } = useSelector((state) => state.sharedResources);
  const handleAccountNameOptionSelect = (value) => {
    setSelectedValue(value);

    const accountNameByOption = {
      legalname:
        payload?.legalName || panVerificationData?.pan_details?.full_name || "",
      username: payload?.userName || "",
      bankaccountname: bankAccountName || "",
    };
    const accountName = accountNameByOption[value];

    if (accountName === undefined) return;

    setPayload((prevPayload) => ({
      ...prevPayload,
      account_name: accountName,
    }));
    setAccountNameValidation(
      accountName.trim().length > GlobalConfiguration.lengthCheckZero,
    );
  };
  const handleRadioBtn = (event) =>
    handleAccountNameOptionSelect(event.target.value);
  const handleDivBtn = handleAccountNameOptionSelect;

  const handleChange = (e) => {
    let { name, value } = e.target;
    value = value.replace(/\s+/g, " ");

    if (payload) {
      const newObj = { ...payload, [name]: value };
      setPayload(newObj);
      if (name === "account_name") {
        const trimmedLength = value.trim().length;

        if (trimmedLength > GlobalConfiguration.lengthCheckZero) {
          let matchedValue = "customname";
          if (value === panVerificationData?.pan_details?.full_name) {
            matchedValue = "legalname";
          } else if (value === payload.userName) {
            matchedValue = "username";
          } else if (value === bankAccountName) {
            matchedValue = "bankaccountname";
          }
          setSelectedValue(matchedValue);

          const isCustomName =
            matchedValue !== "legalname" &&
            matchedValue !== "username" &&
            matchedValue !== "bankaccountname";
          const meetsMinLength =
            !isCustomName ||
            trimmedLength >= GlobalConfiguration.lengthCheckThree;

          setAccountNameValidation(meetsMinLength);
        } else {
          setAccountNameValidation(false);
        }
      }
    }
  };
  useEffect(() => {
    if (accountNameValidation) {
      BenEnableNextButton(false);
      parentCreateBen({
        accountname: accountNameValidation,
      });
    } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
      parentCreateBen({
        accountname: accountNameValidation,
      });
      BenEnableNextButton(true);
    }
  }, [accountNameValidation, activeStep]);
  return (
    <div className="px-padding-md lg:px-padding-base pb-padding-md py-padding-md Qsmd:py-padding-base">
      <CommonLayout>
        <AccountName
          handleChange={handleChange}
          accountName={payload?.account_name}
          handleDivBtn={handleDivBtn}
          handleRadioBtn={handleRadioBtn}
          selectedRadioValue={selectedValue}
          legalName={payload?.legalName}
          type={"user"}
          userName={payload?.userName}
          bankAccountName={bankAccountName}
          setSelectedValue={setSelectedValue}
          placeHolder={"Account name"}
        />
      </CommonLayout>
    </div>
  );
};

export default FieldForceAccountName;
